<div class="loading" *ngIf="isLoading">
    <mat-progress-bar class="progress-bar" mode="indeterminate" color="accent"></mat-progress-bar>
</div>

<div class="upload-view">
    <aside class="side-block">
        <h3 *ngIf="selProvider" [ngSwitch]="selProvider.code">
            <ng-container *ngSwitchCase="'sic'">
                {{'files.form.provider.title.sic.fullLabel' | translate}}
                <app-tooltip [text]="'files.form.provider.title.sic.summary' | translate"></app-tooltip>
            </ng-container>
            <ng-container *ngSwitchCase="'sicbxl'">
                {{'files.form.provider.title.sicbxl.fullLabel' | translate}}
                <app-tooltip [text]="'files.form.provider.title.sicbxl.summary' | translate"></app-tooltip>
            </ng-container>
            <ng-container *ngSwitchCase="'bbc2020'">
                {{'files.form.provider.title.bbc.fullLabel' | translate}}
                <app-tooltip [text]="'files.form.provider.title.bbc.summary' | translate"></app-tooltip>
            </ng-container>
            <ng-container *ngSwitchDefault>
                {{'files.form.provider.title.default.fullLabel' | translate}}
                <app-tooltip [text]="'files.form.provider.title.default.summary' | translate"></app-tooltip>
            </ng-container>
        </h3>
        <form *ngIf="providers && providers.length > 1">
            <p>{{'files.form.provider.providerSelect.fullLabel' | translate}} :</p>
            <mat-radio-group class="budget-options" name="provider" id="provider" [(ngModel)]="selProvider">
                <mat-radio-button *ngFor="let provider of providers" [value]="provider"> {{ provider.code }}
                </mat-radio-button>
            </mat-radio-group>
        </form>
    </aside>

    <section class="main-block" *ngIf="selProvider">
        <form>
            <mat-form-field class="file-select" *ngIf="selProvider.fileTypes && selProvider.fileTypes.length > 1">
                <mat-label>{{ 'files.form.provider.typeSelect.shortLabel' | translate }}</mat-label>
                <mat-select name="fileType" id="fileType" [(ngModel)]="selProvider.selFileType">
                    <mat-option *ngFor="let fileType of selProvider.fileTypes" [value]="fileType">
                        {{ fileType.text? fileType.text.shortLabel : fileType.code }}
                    </mat-option>
                </mat-select>
            </mat-form-field>


            <section class="checkbox" *ngIf="canImportClient">
                <mat-checkbox name="isClientImport" [(ngModel)]="isClientImport">
                    {{ 'files.form.clientImport.shortLabel' | translate }}
                    <app-tooltip [text]="'files.form.clientImport.summary' | translate"></app-tooltip>
                </mat-checkbox>
            </section>
        </form>

        <app-upload-multi
            *ngIf="!selProvider.fileTypes.length || selProvider.selFileType"
            (afterFilesUpload)="sendFilesInfo($event)"></app-upload-multi>
    </section>
</div>
